import { render, staticRenderFns } from "./SeatMap.vue?vue&type=template&id=07201fa4&"
import script from "./SeatMap.vue?vue&type=script&lang=ts&"
export * from "./SeatMap.vue?vue&type=script&lang=ts&"
import style0 from "./SeatMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports